import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const View = styled.div`
    padding-top: 20px;
    padding-bottom: 20px;
    padding-left: 36px;
    position: relative;
    font-size: 18px;
    color: #4a4a4a;
    font-style: italic;

    &::before {
        content: '';
        width: 1px;
        height: 100%;
        position: absolute;
        top: 0;
        left: 14px;
        background-color: #4a4a4a;
        transform: rotate(35deg);
    }
`;

const Sup = styled.sup`
    padding-left: 6px;
    font-size: inherit;
`;

const Additional = styled.div`
    font-size: 11px;
    font-style: normal;

    a {
        color: inherit;

        &:hover {
            opacity: 0.75;
        }
    }
`;

const Price = props => {
    return (
        <View className={props.className}>
            {props.children}
            <Sup>{props.currency}</Sup>
            <Additional>{props.additional()}</Additional>
        </View>
    );
};

Price.defaultProps = {
    currency: '€',
    additional: () => null,
};

Price.propTypes = {
    currency: PropTypes.string,
    additional: PropTypes.func,
};

export default Price;



// WEBPACK FOOTER //
// ./src/components/shared/Price.js